module.exports = __webpack_public_path__ + "static/work33-b2542057247bca215fee0bf59db200f1.jpg";